import React, { Component } from 'react'
import { connect } from 'react-redux'

class RolePage extends Component {
  render () {
    return (
      <div>
	      <div className="pd-x-20 pd-sm-x-30 pd-t-20 pd-sm-t-30">
	        <h4 className="tx-gray-800 mg-b-5">Role page</h4>
	      </div>
	      <div className="br-pagebody">
	        <div className="br-section-wrapper">
	        Role Page
	        </div>
	      </div>  
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({})

export default connect(mapStateToProps, {})(RolePage)



// WEBPACK FOOTER //
// ./src/containers/RolePage.js